import React from 'react';
const SRC = 'https://static.wixstatic.com/media/8f5152_9c9b518c839548d68838a8d097857b62~mv2.gif';
export function BlankImage({ className = 'blank-image', width, height = 1, alt = '', }) {
    return (React.createElement("img", { className: className, src: SRC, width: width, height: height, style: { border: '0px' }, alt: alt }));
}
//# sourceMappingURL=blank-image.js.map